import { c as _c } from "react/compiler-runtime";
import { RefObject, useCallback, useEffect } from 'react';
export const useIframeTouchOutsideUnLock = (iframeRef, setScrollLock) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== iframeRef || $[1] !== setScrollLock) {
    t0 = event => {
      if (iframeRef.current && iframeRef.current.contains(event.target as Node)) {
        return;
      }
      setScrollLock?.(false);
    };
    $[0] = iframeRef;
    $[1] = setScrollLock;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleTouch = t0;
  let t1;
  let t2;
  if ($[3] !== handleTouch) {
    t1 = () => {
      document.addEventListener("touchstart", handleTouch, {
        passive: true
      });
      return () => {
        document.removeEventListener("touchstart", handleTouch);
      };
    };
    t2 = [handleTouch];
    $[3] = handleTouch;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
};